import React, { Component } from 'react';
import { translate } from '../../base/i18n/functions';
import { IconErrorLoadImg } from '../../base/icons/svg';
import Icon from '../../base/icons/components/Icon';
/**
 * React component for displaying a preview of a DesktopCapturerSource.
 *
 * @augments Component
 */
class DesktopSourcePreview extends Component {
    /**
     * Initializes a new DesktopSourcePreview instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            srcImage: '',
            hasLoadError: false
        };
        this._onClick = this._onClick.bind(this);
        this._onDoubleClick = this._onDoubleClick.bind(this);
        this._onErrorLoadThumbnailImage = this._onErrorLoadThumbnailImage.bind(this);
    }
    componentDidMount() {
        this.updateThumbnailURL();
    }
    componentDidUpdate() {
        if (!this.state.srcImage && this.state.hasLoadError) {
            this.updateThumbnailURL();
        }
    }
    updateThumbnailURL() {
        let srcImage = this.props.source.thumbnail.dataUrl;
        // legacy thumbnail image
        if (typeof this.props.source.thumbnail.toDataURL === 'function') {
            srcImage = this.props.source.thumbnail.toDataURL();
        }
        this.setState({ srcImage: srcImage || '', hasLoadError: false });
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const selectedClass = this.props.selected ? 'is-selected' : '';
        const displayClasses = `desktop-picker-source ${selectedClass}`;
        return (React.createElement("div", { className: displayClasses, onClick: this._onClick, onDoubleClick: this._onDoubleClick },
            this.state.hasLoadError
                ? this._renderErrorLoadThumbnailImage()
                : this._renderThumbnailImageContainer(),
            React.createElement("div", { className: 'desktop-source-preview-label' }, this.props.source.name)));
    }
    /**
     * Render thumbnail screenshare image.
     *
     * @returns {Object} - Thumbnail image.
     */
    _renderThumbnailImageContainer() {
        const srcImage = this.state.srcImage;
        return (React.createElement("div", { style: {
                height: '126px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            } },
            React.createElement("div", { className: 'desktop-source-preview-image-container' }, this._renderThumbnailImage(srcImage))));
    }
    _renderErrorLoadThumbnailImage() {
        return (React.createElement("div", { className: 'desktop-source-preview-thumbnail-error-stub' },
            React.createElement(Icon, { src: IconErrorLoadImg })));
    }
    /**
     * Render thumbnail screenshare image.
     *
     * @param {string} src - Of the image.
     * @returns {Object} - Thumbnail image.
     */
    _renderThumbnailImage(src) {
        return (React.createElement("img", { alt: this.props.t('welcomepage.logo.desktopPreviewThumbnail'), className: 'desktop-source-preview-thumbnail', src: src, onError: this._onErrorLoadThumbnailImage }));
    }
    /**
     * Invokes the passed in onClick callback.
     *
     * @returns {void}
     */
    _onClick() {
        const { source } = this.props;
        this.props.onClick(source.id, source.type, source.dimensions);
    }
    /**
     * Invokes the passed in onDoubleClick callback.
     *
     * @returns {void}
     */
    _onDoubleClick() {
        const { source } = this.props;
        this.props.onDoubleClick(source.id, source.type, source.dimensions);
    }
    _onErrorLoadThumbnailImage() {
        this.setState({ hasLoadError: true });
    }
}
export default translate(DesktopSourcePreview);
